import { Centred, Contents } from '../../styles/mixins'
import { RichText } from '../../styles/mixins'

const styles = theme => ({
  centred: {
    ...Centred(theme)
  },
  contents: {
    ...Contents(theme)
  },
  text: {
    ...RichText(theme),
  },
  title: {
    fontWeight: 800,
    textTransform: 'uppercase'
  },
  thing: {
    minHeight: '60vh',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  thingCandy: {
    minHeight: '60vh',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  candyTitle: {
    color: theme.palette.grey[600],
    fontWeight: 800,
    textTransform: 'uppercase',
    marginBottom: theme.spacing.unit * 2,
  },
  candyText: {
    marginBottom: theme.spacing.unit * 5,
  },
  thingTakeaway: {
    background: '#047F8F',
    minHeight: '60vh',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  takeawayTitle: {
    color: 'rgba(255,255,255,1)',
    fontWeight: 800,
    textTransform: 'uppercase',
    marginBottom: theme.spacing.unit * 2,
  },
  takeawayText: {
    color: 'rgba(255,255,255,1)',
    marginBottom: theme.spacing.unit * 5,
  },
  takeawayDownloadTitle: {
    color: 'rgba(255,255,255,1)',
    fontWeight: 400,
    // textTransform: 'uppercase'
  },
  takeawayDownloadText: {
    color: 'rgba(255,255,255,1)',
  },
  takeawayDownloadButton: {
    marginTop: theme.spacing.unit * 5,
    '& span': {
      color: 'rgba(255,255,255,1)',

    }
  }

})

export default styles



// WEBPACK FOOTER //
// ./src/components/thing/styles.js